export function getHasRecruiterAvailableSlots({ recruiterStatsQuery, availableActions, event, participant, exponent }) {
  return recruiterStatsQuery?.isLoading ? true :
    availableActions
      .acceptApplication
      .isRecruiterHasAvailableTimeslots({
        event, participant, exponent, recruiter: recruiterStatsQuery.data
      });
}
